export default {
  isReindexing: false,
  title: "",
  nickname: "",
  colourScheme: "",
  lifeCycleCallbacks: "",
  configAlertCallbacks: "",
  emailEnabled: false,
  chatBriefing: "",
  chatMemoryEnabled: false,
  emailAccounts: [],
  screenLayouts: [],
  jobs: {
    myJobs: [],
    allJobs: [],
    pages: 1,
  },
  jobLogs: [],
}
